import {useState, useEffect} from 'react';
import {Select} from 'antd';
import {getAllVendors} from "../../api/Api";

export const VendorSelectWidget = ({refresh, onSelect, onApiFail, props}) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        // get all vendors
        getAllVendors().then(vendors => {
            const options = vendors.map(v => {
                return {
                    vendor: v,
                    key: v.id,
                    label: v.company,
                    value: v.company
                }
            });
            setOptions(options);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [onApiFail, refresh])

    return <Select style={{textAlign: 'left', width: '400px'}} placeholder={'vendor'} options={options} onSelect={onSelect} />
}